import { render, staticRenderFns } from "./PDatePicker.vue?vue&type=template&id=9a84c10e&scoped=true"
import script from "./PDatePicker.vue?vue&type=script&lang=js"
export * from "./PDatePicker.vue?vue&type=script&lang=js"
import style0 from "./PDatePicker.vue?vue&type=style&index=0&id=9a84c10e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a84c10e",
  null
  
)

export default component.exports